import qs from 'qs';
import { network } from 'services/network';
import { orderBy } from 'lodash';
import { useQuery } from 'react-query';
import { IProgramVersion } from 'components/common/VersionCompareSelectorSection/VersionCompareSelectorWrapper/VersionCompareSelectorWrapper';

const queryFn = ({ projectId, contractId }: GetProjectVersions) => {
    const querystring = qs.stringify(
        { contractId: contractId || -1, projectId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getStoredXerFileVersions${querystring}`;
    return network.get(url).then((response) => response.data);
};
export const useQueryGetProjectVersions = (params: GetProjectVersions) => {
    return useQuery<IProgramVersion[], QueryError>({
        queryKey: ['getProjectVersions', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.projectId),
        placeholderData: [],
        select: (data) => {
            return orderBy(data, ['uploadedDate'], ['desc']);
        },
    });
};

interface GetProjectVersions {
    projectId?: number | null;
    contractId?: number | null;
}
